import {LocalPlayerContext} from '../offline/LocalPlayerContext';
import {useEffect,useState,useContext} from 'react';
import {cachedIdentity,loadIdentity,subscribeIdentity} from './identityCache';
export default function usePlayerIdentity(username,fallback={}){
 const local=useContext(LocalPlayerContext),owner=String(username||'').toLowerCase();
 const [,render]=useState(0);
 useEffect(()=>{if(local||!owner)return;const unsubscribe=subscribeIdentity(owner,()=>render(n=>n+1));loadIdentity(owner);const refresh=e=>{if(!e.detail?.username||String(e.detail.username).toLowerCase()===owner)loadIdentity(owner,{force:true,token:e});};
 const events=['kelimo-player-name-updated','kelimo-avatar-updated','kelimo-cosmetics-updated','kelimo-badges-updated'];for(const event of events)window.addEventListener(event,refresh);
 return()=>{unsubscribe();for(const event of events)window.removeEventListener(event,refresh);};},[owner,local]);
 return local?local.players?.[owner]||fallback:cachedIdentity(owner)||fallback;
}
